export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registration Information"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save Data"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmed"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This field is public and visible to other users"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This field is hidden from other users"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identity Verification"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verified"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In progress"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not verified"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start Verification"])}
}